export const DEFAULT_COMPANY_BRANDING = {
  company: 'meit',
  logo: {
    image: 'https://pruebameit.b-cdn.net/Meit-logo-color-optimized.png',
    link: 'https://pidemeit.com',
  },
  colors: [
    {
      name: '--color-primary',
      shades: {
        10: '#F9E9FF',
        50: '#EFDFF5',
        100: '#CF9EE0',
        200: '#AE5DCC',
        300: '#772E92',
      },
    },
    {
      name: '--color-secondary',
      shades: {
        10: '#E6F9F6',
        50: '#DEF6F5',
        100: '#9BE3E2',
        200: '#84DDDB',
        300: '#59D1CE',
      },
    },
    {
      name: '--color-primary-text',
      shades: {
        10: '#F9E9FF',
        50: '#EFDFF5',
        100: '#CF9EE0',
        200: '#AE5DCC',
        300: '#772E92',
      },
    },
    {
      name: '--color-secondary-text',
      shades: {
        50: '#000000',
      },
    },
  ],
  banners: [
    {
      seccion: 'principal',
      title:
        'Brindamos beneficios exclusivos y personalizados para tus beneficiarios.',
      text: [
        'Tus beneficiarios acceden a precios exclusivos en 8 categorías y pueden redimir cupones de consumo según el plan de membresía asignado.',
      ],
      image: 'https://pruebaMeit.b-cdn.net/originalBanner.png',
      buttons: [
        {
          action: 'https://calendly.com/carlos-meit/meit?month=2024-08',
          link: null,
          title: 'Agenda un demo con nosotros',
        },
      ],
    },
    {
      seccion: 'medio1',
      title: '',
      text: [],
      image: 'https://pruebaMeit.b-cdn.net/spacars.jpeg',
      buttons: [],
    },
    {
      seccion: 'medio2',
      title: '',
      text: [],
      image: 'https://pruebaMeit.b-cdn.net/cajasMeit.png',
      buttons: [],
    },
    {
      seccion: 'seccionInicio',
      title: '',
      text: [],
      image: 'https://pruebaMeit.b-cdn.net/cajasMeit.png',
      buttons: [],
    },
    {
      seccion: 'final',
      title: '¿CLIENTES O ALIADOS? ¿AMBOS?',
      text: [
        'Somos tu partner (meit!) para construir la Organización que siempre has soñado: donde tus colaboradores están motivados a entregar los mejores resultados, a la vez que se sienten económicamente protegidos.',
        'Además, ofrece tus productos y servicios para otras compañías, fortaleciendo a través de meit! tus ventas corporativas.',
      ],
      image: '',
      link: '',
      buttons: [
        {
          title: '¿Quieres ofrecer beneficios a tus beneficiarios?',
          action: `${process.env.NEXT_PUBLIC_DASHBOARD_URL}/sign-in/company`,
          link: null,
        },
        {
          title: '¿Quieres ofrecer tus productos en Meit!?',
          action: `${process.env.NEXT_PUBLIC_DASHBOARD_URL}/sign-in/ally`,
          link: null,
        },
      ],
    },
  ],
  homeCards: [],
  footer: {},
};
